import { yup } from '@guiker/yup-util'

export const bookingIdSchema = yup.object({
  bookingId: yup.string().required(),
})

export type BookingIdSchema = yup.InferType<typeof bookingIdSchema>
